export enum ProvisioningRequestStatus {
	Requested,
	Approved,
	Rejected,
	InProgress,
	Ready,
	Failed,
	Deleted,
}
